import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { adminInfoDemoData } from '../../../../data/AdminDemoData';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { useAdminListInfo } from '../AdminList/AdminsListProvider';
import { ApiAdminInfoData } from '../AdminsPageOperation';

const AdminInfoContext = createContext();

export const useAdminInfo = () => useContext(AdminInfoContext);

function AdminInfoProvider({ id, children }) {
    const { setMessage } = useTemplate();
    const [addressShow, setAddressShow] = useState(false);
    const [openAppInfoModal, setOpenAppInfoModal] = useState(false);
    const [addNewSubscriptionModal, setAddNewSubscriptionModal] = useState(false);
    const [adminInfoData, setAdminInfoData] = useState(adminInfoDemoData);
    // const [permissionsData, setPermissionsData] = useState([{}]);
    const [reloadKey, setReloadKey] = useState(0);
    const [loading, setLoading] = useState(false);

    const { infoReloadKey } = useAdminListInfo();

    // reload state

    useEffect(() => {
        setLoading(true);
        setAdminInfoData(adminInfoDemoData);
        ApiAdminInfoData(id)
            .then(({ data }) => {
                setLoading(false);
                setAdminInfoData(data?.user);
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error.toString(0) });
                setLoading(false);
                setAdminInfoData({});
            });
    }, [id, setMessage, reloadKey, infoReloadKey]);

    // useEffect(() => {
    //     setPermissionsData([{}]);
    //     ApiLoadPermissionsData(id)
    //         .then(({ data }) => {
    //             setPermissionsData(data?.permissions);
    //         })
    //         .catch((error) => {
    //             setMessage({ type: 'error', text: error.toString(0) });
    //             setPermissionsData([{}]);
    //         });
    // }, [id, setMessage, reloadKey]);

    const value = useMemo(() => {
        // -- Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        // App info modal show/hide handler
        const handleAppInfoModal = () => setOpenAppInfoModal(true);
        const handleShowNewSubScription = () => setAddNewSubscriptionModal(true);

        // Address show hide handler
        const handleAddressBoxShow = () => setAddressShow((d) => !d);

        return {
            // customer details data
            adminInfoData,
            setAdminInfoData,

            // permissions data
            // permissionsData,
            // setPermissionsData,

            // Reload Key
            loading,
            reloadKey,
            setReloadKey,

            // modal control
            openAppInfoModal,
            setOpenAppInfoModal,
            addNewSubscriptionModal,
            setAddNewSubscriptionModal,

            // handle
            handleAppInfoModal,
            handleShowNewSubScription,
            handleReload,

            // Address Box show and Hide
            addressShow,
            setAddressShow,
            handleAddressBoxShow
        };
    }, [
        addNewSubscriptionModal,
        addressShow,
        adminInfoData,
        // permissionsData,
        loading,
        reloadKey,
        openAppInfoModal,
        setReloadKey
    ]);
    return <AdminInfoContext.Provider value={value}>{children}</AdminInfoContext.Provider>;
}

export default AdminInfoProvider;
